import React, {useState} from 'react';
import cl from  './CourseItem.module.css'
import teacher from '../../../Assets/icons/teacher.svg'
import More from "../More/More";
import calendar from '../../../Assets/icons/calendar_today.svg'
import {format, parseISO} from "date-fns";

const CourseItem = ({item, setCourses}) => {
    const entity = 'courses'
    const [activeMenuId, setActiveMenuId] = useState(null);

    const toggleMenu = (id) => {
        setActiveMenuId(activeMenuId === id ? null : id);
    };

    return (
        <div className={cl.card}>
            <div className={cl.info}>
                <div className={cl.upperPart}>
                    <div className={cl.courseName}>
                    <span>
                        {item.code}
                    </span>
                        {item.title}
                    </div>
                    <div className={cl.period}>
                        <img src={calendar} alt={"Calendar"}/>
                        <p>
                            {format(parseISO(item.startDate), "dd.MM.yyyy")} - {format(parseISO(item.endDate), "dd.MM.yyyy")}
                        </p>
                    </div>
                </div>
                <div className={cl.teacher}>
                    <div className={cl.teacherName}>
                        <img src={teacher} alt={"Teacher"}/>
                        {item.teacher.name} {item.teacher.surname}
                    </div>
                    <More
                        id={item.id}
                        entity={entity}
                        isOpen={activeMenuId === item.id}
                        onToggle={() => toggleMenu(item.id)}
                        setCourses={setCourses}
                    />
                </div>
            </div>
        </div>
    );
};

export default CourseItem;